import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { DataServiceService } from 'src/app/services/data-service.service';
import { SeoService } from 'src/app/services/seo.service';
import { Meta } from '@angular/platform-browser';
import { GlobalService } from 'src/app/services/global.service';
import { AdvisorCardComponent } from '../_components/advisor-card/advisor-card.component';
import { CssCardComponent } from '../_components/advisor-card/css-card/css-card.component';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-css-list',
    templateUrl: './css-list.component.html',
    styleUrls: ['./css-list.component.scss'],
    imports: [AdvisorCardComponent,CssCardComponent,CommonModule]
})
export class CssListComponent implements OnInit {

  title = "Investing for Catholics Client Service Specialists";

  clientServices;

  constructor(private dataservice: DataServiceService, private seoservice: SeoService, private meta: Meta, private globalservice: GlobalService, private cdr: ChangeDetectorRef) {

    this.dataservice.getClientServices("?$filter=id in ("+globalservice.clientServices.map(x=> x.id)+") and id%20ne%2069").subscribe(resp => {
      resp = resp.map( x => { 
        x.imageUrl?(x.imageUrl = x.imageUrl.replace("329x461", "270x378")):(null); 
        x.url=(x.url.replace("https://www.ifa.com/",""))
        return x });
 
     this.clientServices = resp;
      this.cdr.detectChanges();
   })

   }

  ngOnInit() {

    this.seoservice.updateTitle(this.title);
  	this.meta.addTag({name: 'keywords', content: 'investing for catholics client service specialist, ifc client service specialist, ifc css'});
    this.meta.addTag({name: 'description', content: 'Investing gor Catholics client service specialist.'});
    this.meta.addTag({name: 'author', content: 'Investing for Catholics (IFC)'});
    this.meta.addTag({name: 'robots', content: 'index, follow'});

  }

}
